export default __webpack_public_path__ + "static/media/ZZC_7831.b2ebb5e6.jpg";